<!-- Container principal da página  -->
<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'firmwares.firmware-label' | translate }}"
      pageTitle="{{ 'firmwares.generate-firmware-label' | translate }}">
    </app-page-header>

    <div class="row">
      <div class="col-lg-5 col-xl-4 col-sm-12">
        <div class="component-forms-box">
          <app-register-form></app-register-form>
          <div class="form-fields-box" [ngClass]="!filterFirmwares ? 'closed' : ''" [formGroup]="filterFirmwareForm">
            <h2 (click)="filterFirmwaresOpen()">
              {{ "firmwares.filter-firmware" | translate }}
            </h2>
            <hr [ngClass]="!filterFirmwares ? 'hr-open' : ''" />

            <!-- Sessão de filtro de firmwares -->
            <div class="form-step">
              <div class="circle-number">1</div>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-name" | translate }}
                </mat-label>
                <input matInput formControlName="nameFilterForm" />
              </mat-form-field>
            </div>

            <div class="form-step">
              <div class="circle-number">2</div>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-major" | translate }}
                </mat-label>
                <input matInput type="number" min="0" formControlName="majorFilterForm" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-minor" | translate }}
                </mat-label>
                <input matInput type="number" min="0" formControlName="minorFilterForm" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-revision" | translate }}
                </mat-label>
                <input matInput type="number" min="0" formControlName="revisionFilterForm" />
              </mat-form-field>
            </div>
            <div class="d-flex">
              @if (!firmwaresLoading) {
              <button class="btn btn-success m-2 w-50" (click)="filterFirmware(null)">
                {{ "firmwares.button-filter" | translate }}
              </button>
              }
              @if (firmwaresLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
              @if (!firmwaresLoading) {
              <button class="btn btn-secondary m-2 w-50" (click)="resetFilter()">
                {{ "firmwares.reset-button-filter" | translate }}
              </button>
              }
            </div>
          </div>

          <!-- Sessão do campo para criar Firmware -->
          <div class="form-fields-box" [ngClass]="!registerFirmwares ? 'closed' : ''" [formGroup]="createFirmwareForm">
            <h2 (click)="registerFirmwaresOpen()">
              {{ "firmwares.create-firmware" | translate }}
            </h2>
            <hr [ngClass]="!registerFirmwares ? 'hr-open' : ''" />

            <div class="form-step">
              <div class="circle-number">1</div>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-name" | translate }}
                </mat-label>
                <input matInput formControlName="nameCreateForm" />
              </mat-form-field>
            </div>

            <div class="form-step">
              <div class="circle-number">2</div>
              <div class="date-picker-input">
                <p-datepicker formControlName="releaseDateCreateForm" dateFormat="dd/mm/yy"
                  placeholder="{{ 'firmwares.label-release-date' | translate }}" pInputMask="99/99/9999"
                  appendTo="body" />
              </div>
            </div>

            <div class="form-step">
              <div class="circle-number">3</div>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-major" | translate }}
                </mat-label>
                <input matInput type="number" min="0" formControlName="majorCreateForm" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-minor" | translate }}
                </mat-label>
                <input matInput type="number" min="0" formControlName="minorCreateForm" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-revision" | translate }}
                </mat-label>
                <input matInput type="number" min="0" formControlName="revisionCreateForm" />
              </mat-form-field>
            </div>

            <div class="form-step">
              <div class="circle-number">4</div>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-description" | translate }}
                </mat-label>
                <textarea matInput formControlName="descriptionCreateForm"></textarea>
              </mat-form-field>
            </div>

            <div class="form-step">
              <div class="circle-number">5</div>
              @if (!firmwaresLoading) {
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "firmwares.label-compatible-hardware" | translate }}
                </mat-label>
                <mat-select value="default">
                  <mat-option disabled value="default">
                    {{ selectedHardwaresIdList.length }}
                    {{ "firmwares.selected-hardware" | translate }}
                  </mat-option>
                  @for (newHardware of hardwaresList; track newHardware) {
                  <span class="d-flex justify-content-start align-items-center">
                    <mat-checkbox class="ms-2 me-2" (change)="filterSelectedHardwares($event, newHardware.id)"
                      class="ms-2 me-2">
                      {{ newHardware.name }} ({{ newHardware.version }})
                    </mat-checkbox>
                  </span>
                  }
                </mat-select>
              </mat-form-field>
              }
              @if (firmwaresLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
            </div>

            <!-- Sessão do campo para criar novo hardware compatível -->
            <mat-accordion class="newHardware" [formGroup]="createHardwareForm">
              <mat-expansion-panel (opened)="panelOpenFirmware = true" (closed)="panelOpenFirmware = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ "firmwares.create-new-hardware" | translate }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="form-step">
                  <div class="circle-number">1</div>
                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "firmwares.label-name" | translate }}
                    </mat-label>
                    <input matInput formControlName="nameHardwareCreateForm" />
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <div class="circle-number">2</div>
                  <div class="date-picker-input">
                    <p-datepicker formControlName="releaseDateHardwareCreateForm" dateFormat="dd/mm/yy"
                      placeholder="{{ 'firmwares.label-release-date' | translate }}" pInputMask="99/99/9999"
                      appendTo="body" />
                  </div>
                </div>

                <div class="form-step version">
                  <div class="circle-number">3</div>
                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "firmwares.label-major" | translate }}
                    </mat-label>
                    <input matInput type="number" min="0" formControlName="majorHardwareCreateForm" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "firmwares.label-minor" | translate }}
                    </mat-label>
                    <input matInput type="number" min="0" title="Menor" formControlName="minorHardwareCreateForm" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "firmwares.label-revision" | translate }}
                    </mat-label>
                    <input matInput type="number" min="0" title="Revisão"
                      formControlName="revisionHardwareCreateForm" />
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <div class="circle-number">4</div>
                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "firmwares.label-description" | translate }}
                    </mat-label>
                    <textarea matInput formControlName="descriptionHardwareCreateForm"></textarea>
                  </mat-form-field>
                </div>
                <button class="btn btn-success" (click)="createNewHardware()" [disabled]="createHardwareForm.invalid">
                  {{ "firmwares.button-save" | translate }}
                </button>
                @if (registerHardwareLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </mat-expansion-panel>
            </mat-accordion>

            <button class="btn btn-success" (click)="createFirmware()" [disabled]="createFirmwareForm.invalid">
              {{ "firmwares.button-save" | translate }}
            </button>
            @if (registerFirmwareLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
          </div>
        </div>
      </div>

      @if (length > 0) {
      <div class="col-lg-7 col-xl-8 col-sm-12">

        <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
          [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
          (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
        </app-table-header>

        <div class="table-container mt-2 mt-lg-3 mt-xl-3">
          <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
            (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name">{{ "firmwares.label-name" | translate }}</th>
                <th pSortableColumn="version">{{ "firmwares.version-firmware" | translate }}</th>
                <th pSortableColumn="releaseDate"> {{ "firmwares.label-release-date" | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
              <tr>
                <td>{{ row.name }}</td>
                <td>{{ row.version }}</td>
                <td>
                  {{ row.releaseDate | date : "dd/mm/yyyy" }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      }
    </div>
  </div>